import { useEffect } from 'react';

const useOnMount = (fn: Function, unmountFn?: Function) => {
  useEffect(() => {
    fn();
    return () => {
      if (unmountFn) {
        unmountFn();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useOnMount;
